<app-project-settings-layer-detail-template
    [canDelete]="canDelete()"
    [canEditSymbology]="canEditSymbology()"
    [subtitle]="labelByLayerType[layerBloc.value()!.type] | transloco: { COUNT: 1 }"
    [title]="layerBloc.value()?.name ?? ''"
    (deleteLayer)="deleteLayer(layerBloc.value()!.id)"
    (goToPreviousPage)="closeDetail(layerBloc.value()!.id)">
    <div class="my-8 max-w-full">
        <div class="flex flex-col">
            <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">
                {{ 'source' | transloco }}
            </p>
            <p class="!m-0 max-w-full break-words whitespace-normal">
                {{ layerBloc.value()!.url ?? '-' }}
            </p>
        </div>
    </div>
</app-project-settings-layer-detail-template>
